import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '@aws-amplify/auth';
import { Spinner } from 'react-bootstrap';

/**
 * /my-account  — Resolve the current Cognito user's UUID and redirect to their
 * customer profile page.  This is linked to in the layaway contract SMS.
 */
export default function MyAccountRedirect() {
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    useEffect(() => {
        getCurrentUser()
            .then((user) => {
                const uuid = user.userId || user.username;
                navigate(`/customers/view-customer?customerID=${uuid}`, { replace: true });
            })
            .catch(() => {
                setError('Please log in to view your account.');
            });
    }, [navigate]);

    if (error) {
        return (
            <div className="centered mt-5">
                <p className="text-danger">{error}</p>
            </div>
        );
    }

    return (
        <div className="centered mt-5">
            <Spinner animation="border" />
            <p className="mt-3 text-muted">Loading your account…</p>
        </div>
    );
}
